import PreviewGalleryModal from './PreviewGalleryModal.component';

export default PreviewGalleryModal;